module.exports = __webpack_public_path__ + "static/media/freedom.793fd05e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/freedom.svg
// module id = 245
// module chunks = 0